import React, { FC } from 'react';
import cx from 'classnames';
import { ArticleBlockProps } from '../ArticleBlock';
import * as SC from './styled';
export type ArticleRecipesBlockProps = {
  className?: string;
  recipes: ArticleBlockProps[];
};
const ArticleRecipesBlock: FC<ArticleRecipesBlockProps> = props => {
  const {
    className,
    recipes
  } = props;
  return <SC.ArticleRecipesBlock className={cx('ArticleRecipesBlock', className)}>
      {recipes.map((recipe, index) => <SC.Article {...recipe} key={index} />)}
    </SC.ArticleRecipesBlock>;
};
export default ArticleRecipesBlock;